<template>
  <div class="lang-select">
    <span :class="{ active: language === 'zh' }" @click="handleSetLanguage('zh')">中文</span>/
    <span :class="{ active: language === 'en' }" @click="handleSetLanguage('en')">EN</span>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  watch: {
    language: {
      handler: function(newValue, oldValue) {
        if (newValue === 'spanish') this.handleSetLanguage('en')
      },
      immediate: true
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // this.$router.go(0) // safari浏览器不支持
      window.location.reload()
      this.$emit('change', lang)
    }
  }
}
</script>
<style lang="scss" scoped>
.lang-select {
  font-size: 15px !important;
  display: inline-block;
  font-family: "Microsoft YaHei", SimHei, Helvetica, Arial, sans-serif;
  span {
    font-weight: bold;
    cursor: pointer;
    color: $menuActiveColor;
    &.active {
       color: #fff;
    }
    &:hover {
      color: #fff;
    }
  }
}
</style>
